import type { SVGProps } from 'react';

const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 13c-.55 0-1 .45-1 1v3c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1H6C4.35 6 3 7.35 3 9v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-3c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M11 15c.55 0 1-.45 1-1 0-2.76 2.24-5 5-5h.59l-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3-3a.996.996 0 0 0 0-1.41l-3-3a.996.996 0 1 0-1.41 1.41l1.29 1.29h-.59c-3.86 0-7 3.14-7 7 0 .55.45 1 1 1z"
    />
  </svg>
);
export default SvgShare;
